<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 40vw">
      <div class="modal-header">
        <h5 class="modal-title">Add Doctor's Note</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>

      <div v-if="loading">
        <loader />
      </div>
      <div v-if="!loading" class="modal-body">
        <div class="mt-4 w-full">
          <textarea
            style="width: 100%"
            v-model="noteText"
            rows="4"
            class="w-full border rounded p-2"
            placeholder="Write your note here..."
          ></textarea>
        </div>
      </div>

      <div v-if="!loading" class="modal-footer mt-4">
        <button
          type="button"
          class="btn btn-secondary mr-2"
          @click="closeModal"
        >
          Cancel
        </button>
        <button type="button" class="btn btn-primary" @click="submitNote">
          Save Note
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import loader from "../../special_clinics/dialysis/loader.vue";

export default {
  name: "AddDoctorNoteModal",
  props: {
    visit_id: {
      type: [String, Number],
      required: true,
    },
    note_id: {
      type: [String, Number],
      required: false,
    },
  },
  components: {
    loader,
  },
  data() {
    return {
      noteText: "",
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-add-doc-note-modal");
    },
    async submitNote() {
      if (this.noteText.trim() === "") return;
      this.loading = true;
      try {
        const url =
          this.note_id == null
            ? "doctors-notes/add"
            : "doctors-notes/update/" + this.note_id;
        const body = {
          visit_id: this.visit_id,
          note: this.noteText,
        };
        console.log(body);

        const res = await generalApiRequest(url, "POST", body, 1);

        if (res.status === "success") {
          this.noteText = "";
          this.$emit("note-added"); // 👈 Emit event so parent can refetch notes
          this.closeModal();
        } else {
          alert("Failed to save note.");
        }
      } catch (error) {
        console.error("API error:", error);
        alert("An error occurred while saving the note.");
      }
      this.loading = false;
    },
    async fetch_notes_for_edit() {
      this.loading = true;
      // console.log("9999999999999999999999999999999999999999999999999999999"+this.note_id);

      const url = "getNoteForEdit/" + this.note_id;
      const res = await generalApiRequest(url, "GET", {}, 1);
      console.log(res);

      this.noteText = res.data.note;
      this.loading = false;
    },
  },
  mounted() {
    if (this.note_id) {
      // console.log(this.note_id + " this is the id");
      this.fetch_notes_for_edit();
    }
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
}
</style>
